import React from "react";
import checkmarkSvg from "../assets/checkmark.svg";

export function Checkmark() {
  return <img src={checkmarkSvg} alt="" style={{ padding: "0 1em" }} />;
}
